import { FILTER_SET_MODEL } from '../FilterSet.model';
import ErrorMessage from './ErrorMessage';
import {
  StyledDescription,
  StyledDueDateSelector,
  StyledInputDate,
  StyledSectionTitle
} from './FilterSetForm.style';

const DueDateSelector = ({ value, onChange, validator }) => {
  return (
    <StyledDueDateSelector>
      <StyledSectionTitle>Target Date</StyledSectionTitle>
      <StyledDescription>
        Set a date you expect this project to end. You may always change it
        later.
      </StyledDescription>
      <StyledInputDate
        type='date'
        value={value}
        onChange={e => onChange(e.target.value)}
        data-cy='saved-filter-target-date-value'
      />
      <ErrorMessage
        validationError={validator.validationError}
        type={FILTER_SET_MODEL.METADATA.DUE_DATE}
      />
    </StyledDueDateSelector>
  );
};

export default DueDateSelector;
